import Vue from 'vue'
import store from './store'
import router from './router'
import Mint from 'mint-ui'
import App from './App.vue'
import components from '@/components'
import 'mint-ui/lib/style.css'
import '@/assets/css/index.scss' // global css
import '@/assets/iconfont/iconfont.css' // 引用图标
import { Empty, List, PullRefresh } from 'vant';
// 环境初始化
import '@/utils/init/env-init'
import '@/utils/common/date.js'
// 全局的wx方法
import $wx from '@/utils/init/wx.js';
window.$wx = $wx;
import initSa from '@/utils/common/shence';

// 正式环境打开神策数据
initSa();
// 初始化页面配置
import { useConfig } from '@/pages/config'
useConfig()

Vue.use(Mint)
Vue.use(components)
Vue.use(Empty).use(List).use(PullRefresh)
Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
